<template>
  <div class='bg-light' v-if="device">
    <table class="table table-responsive-sm table-striped">
      <tr>
        <th>{{$t('serial')}}</th>
        <td>
          <span v-text="device.serial"></span>
        </td>
      </tr>
      <tr>
        <th>{{$t('type')}}</th>
        <td>{{device|format_device_type}}</td>
      </tr>
      <tr v-if="mode_param">
        <th>{{$t('frequency')}}</th>
        <td>{{mode_param.frequency}} minutes ({{device.tracker_config.mode|niceMode}})</td>
      </tr>
      <tr v-else>
        <th>Mode</th>
        <td>{{device.tracker_config.mode|niceMode}}</td>
      </tr>
      <tr v-if="mode_param">
        <th>{{$t('alarm')}}</th>
        <td><span v-if="mode_param.smart_alarm">Smart alert activated</span>
          <span v-else-if="mode_param.alarm">Alert activated</span>
          <span v-else>No</span>
        </td>
      </tr>
      <tr>
        <th>Usage</th>
        <td>{{device.tracker_config.usage|formatUsage}}</td>
      </tr>
      <tr>
        <th>Version</th>
        <td>{{device.version}}(build={{device.version_build}})</td>
      </tr>
      <tr>
        <th>{{$t('state')}}</th>
        <td><span v-if="device.tracker_status" v-text="device.tracker_status.state"></span></td>
      </tr>
      <tr>
        <th>{{$t('last_address')}}</th>
        <td>
          <a v-if="last" :href="'https://www.google.com/maps?q='+last.lat+','+last.lng">
            <span v-text="address"></span>
          </a>
        </td>
      </tr>
      <tr>
        <th>{{$t('last_position')}}</th>
        <td><div v-if="last">{{last.lat|roundFloat(5)}}, {{last.lng|roundFloat(5)}}</div></td>
      </tr>
      <tr>
        <th>{{$t('last_event')}}</th>
        <td><span v-if="device.tracker_status"> {{device.tracker_status.last_event| formatDate}}</span></td>
      </tr>
      <tr v-if="show_location_and_uplink_date">
        <th>{{$t('last_location')}}</th>
        <td><span>{{device.tracker_status.last_location| formatDate}}</span></td>
      </tr>
      <tr>
        <th>{{$t('battery')}}</th>
        <td>
          <div v-if="device.tracker_status"> {{device | formatBattery}}</div>
        </td>
      </tr>
      <tr>
        <th>{{$t('operator')}}</th>
        <td>
          <div v-if="device.tracker_status"> {{device.tracker_status.network_operator}}</div>
        </td>
      </tr>
      <tr><th>{{$t('subscription_end_date')}}</th>
      <td><div v-if="device.tracker_status">{{device.tracker_status.sub_end_date| formatDay}}</div></td></tr>
    </table>
  </div>
</template>


<script>
import * as nvxlib from '../nvxcommon'
import {bus} from '../event-bus'
import {HTTP} from '../http-constants'

export default {
  name: 'TrackerPanelInfo',
  data: function () {
    return {
      device: null,
      mode_param: null,
      last: null,
      address: "",
      show_location_and_uplink_date: false,
      allow_edit: false,
    }
  },
  methods: {
    'loadDeviceLastPosition': function (tracker) {
      var self = this;
      self.address = "";
      self.last = null;
      if (tracker.tracker_status.last_location && tracker.tracker_status.last_event != tracker.tracker_status.last_location) {
        self.show_location_and_uplink_date = true;
      } else {
        self.show_location_and_uplink_date = false;
      }
      HTTP.get('/devices/trackers/last/?ids=' + tracker.id,)
          .then(function (re) {
            if (re.data.length) {
              self.last = re.data[0];

              self.resolve_address(self.last);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    getTrackerModeParameter() {
      let self = this;
      HTTP.get('/devices/' + self.device.id + '/tracker_config/mode_param/',)
          .then(function (re) {
            self.mode_param = re.data;
          })
          .catch(function (error) {
            self.mode_param = null;
            console.log(error);
          });
    },
    'resolve_address': function (last) {
      var self = this;
      console.log("Last", last);
      if (!last) {
        return;
      }

      let locationKey = 'lat:' + last.lat.toFixed(4) + ",lng:" + last.lng.toFixed(4);
      var new_address = null;
      if (window.sessionStorage) {
        try {
          new_address = sessionStorage.getItem(locationKey);
        } catch (e) {
          console.log("error getting addr from storage");
        }
      }
      if (new_address != null) {
        self.address = new_address;
      } else {
        self.geocode_position(last.lat, last.lng, function (address) {
          self.address = address;
          sessionStorage.setItem(locationKey, address);
        });
      }
    },
    'geocode_position': function (lat, lng, cb) {
      var position = new google.maps.LatLng(lat, lng);
      var geocoder = new google.maps.Geocoder();
      geocoder.language = window.navigator.language;

      geocoder.geocode({'location': position}, function (results, status) {

        if (status === 'OK') {
          if (results[0]) {
            cb(results[0].formatted_address);
          } else {
            window.alert('No results found');
          }
        } else {
          window.alert('Geocoder failed due to: ' + status);
        }
      });
    },
    'save': function () {
      var self = this;
      HTTP.patch("/devices/" + this.device.id + "/", this.device)
          .then(function (re) {
            self.device = re.data;
          })
          .catch(function (error) {
            console.log(error);
          });
    }
  },
  mounted: function () {
    var self = this;
    nvxlib.getUserRole(function (role) {
      if (role != 'sub_user') {
        self.allow_edit = true;
      }
    });
  },
  created: function () {
    bus.$on('tracker_panel', elem => {
      var action = elem.action;
      if (action == 'info') {
        this.mode_param = null;
        this.device = elem.tracker;
        if (this.device) {
          this.loadDeviceLastPosition(this.device);
          if (this.device.tracker_config) {
            if (['50', '235'].includes(this.device.tracker_config.mode)) {
              this.getTrackerModeParameter();
            }
          }
        }
      } else {
        this.device = null;
      }
    });
  }
}
</script>